import { Box, Skeleton, useTheme } from '@mui/material';

import PurchaseOrdersDetailsFilters from '../components/PurchaseOrderDetailsFilters';
import { useContext } from 'react';
import { PurchaseOrderDetailsContext, PurchaseOrderDetailsValues } from '../contexts/PurchaseOrderDetailsContext';

const PurchaseOrdersDetailsMainArea = () => {
  const { isLoading } = useContext(PurchaseOrderDetailsContext) as PurchaseOrderDetailsValues;
  const theme = useTheme();

  if (isLoading) return (<Box sx={{ mt: '6px' }}>
    <Skeleton variant="rectangular"
      height={1600}
      sx={{ borderRadius: '12px' }}>
    </Skeleton>
  </Box>
  );

  return <PurchaseOrdersDetailsFilters />;
};

export default PurchaseOrdersDetailsMainArea;